/* EVENSKYN Learn and Results (4 Oct 2026). Small, dependency-free, and safe to load twice.
   Everything here is an improvement on a page that already works without it. */
(function () {
  if (window.__evkLearn) return; window.__evkLearn = true;
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  var txt = function (el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); };
  var CHEV = '<svg class="i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6.5 9.5l5.5 5.5 5.5-5.5"></path></svg>';

  /* ---------- hub: routes by task. On a phone each card's heading becomes a button that opens the card. ---------- */
  function tasks() {
    var box = $('[data-lrn-acc]'); if (!box) return;
    var mq = window.matchMedia('(max-width:760px)');
    function on() {
      if (box.getAttribute('data-acc') === 'on') return;
      box.setAttribute('data-acc', 'on');
      $$('.lrn-tk', box).forEach(function (tk, i) {
        var h = $('.lrn-tk-h', tk), p = $('.lrn-tk-p', tk); if (!h || !p) return;
        p.id = p.id || 'lrn-tk-' + i;
        var b = d.createElement('button');
        b.type = 'button'; b.className = 'lrn-tk-b'; b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', p.id);
        while (h.firstChild) b.appendChild(h.firstChild);
        b.insertAdjacentHTML('beforeend', CHEV);
        h.appendChild(b);
        b.addEventListener('click', function () {
          var open = tk.hasAttribute('data-open');
          if (open) tk.removeAttribute('data-open'); else tk.setAttribute('data-open', '');
          b.setAttribute('aria-expanded', open ? 'false' : 'true');
        });
      });
    }
    function off() {
      if (box.getAttribute('data-acc') !== 'on') return;
      box.removeAttribute('data-acc');
      $$('.lrn-tk', box).forEach(function (tk) {
        var h = $('.lrn-tk-h', tk), b = $('.lrn-tk-b', tk); if (!h || !b) return;
        var ic = b.lastElementChild; if (ic && ic.classList.contains('i')) b.removeChild(ic);
        while (b.firstChild) h.insertBefore(b.firstChild, b);
        h.removeChild(b); tk.removeAttribute('data-open');
      });
    }
    function sync() { if (mq.matches) on(); else off(); }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  }

  /* ---------- article ---------- */
  var norm = function (s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };

  /* A title repeated as the first heading of the body is the page's H1 said twice: hide the repeat. */
  function dedupeTitle(prose) {
    var h1 = $('.lrn-at'); if (!h1) return;
    var want = norm(txt(h1));
    $$('h2, h3', prose).slice(0, 2).forEach(function (h) {
      if (norm(txt(h)) !== want) return;
      h.classList.add('lrn-hide');
      var prev = h.previousElementSibling;
      if (prev && /eyebrow|kicker/i.test(prev.className) && txt(prev).length < 80) prev.classList.add('lrn-hide');
    });
  }

  /* Byline, review and disclosure lines that open the body are set smaller, so the answer starts sooner.
     Nothing is hidden. A line the article styles itself (a byline class) is left alone. */
  function metaParas(prose) {
    var META = /^(written|authored|by the |by dr|by team|by evenskyn|reviewed|medically reviewed|last (reviewed|updated|clinically)|published|updated|ownership disclosure|disclosure|fact.?checked)/i;
    var firstHead = $('h2, h3', prose);
    $$('p', prose).slice(0, 8).forEach(function (p) {
      if (firstHead && !(p.compareDocumentPosition(firstHead) & Node.DOCUMENT_POSITION_FOLLOWING)) return;
      if (/byline|deck|eyebrow/i.test(p.className)) return;
      if (META.test(txt(p))) p.classList.add('lrn-mp');
    });
  }

  /* Old posts mark their sections with a bold line instead of a heading. When an article has fewer than two real
     H2s, such lines are announced and drawn as headings. The stored HTML is not changed. */
  function legacyHeads(prose) {
    if ($$('h2', prose).length >= 2) return;
    $$('p, div', prose).forEach(function (el) {
      if (el.children.length !== 1) return;
      var c = el.firstElementChild; if (!/^(STRONG|B)$/.test(c.tagName)) return;
      var t = txt(el); if (t !== txt(c) || t.length < 3 || t.length > 110 || /[.,;:]$/.test(t)) return;
      el.classList.add('lrn-up'); el.setAttribute('role', 'heading'); el.setAttribute('aria-level', '2');
    });
  }

  /* The article's own quick answer is drawn as one card. Skipped when the article already boxes it. */
  function answer(prose) {
    var heads = $$('h2, h3, h4', prose).slice(0, 4);
    for (var i = 0; i < heads.length; i++) {
      var h = heads[i];
      if (!/^((the )?(quick|short) answer|key takeaways?|tl;?dr|in brief|the bottom line|at a glance)\b/i.test(txt(h))) continue;
      var p = h.parentElement, boxed = false;
      while (p && p !== prose) { if (/answer|summary|takeaway|tldr|verdict|callout|box|card/i.test(p.className)) boxed = true; p = p.parentElement; }
      if (boxed) return;
      var els = [h], n = h.nextElementSibling;
      while (n && els.length < 3 && n.tagName === 'P') { els.push(n); n = n.nextElementSibling; }
      if (els.length < 2) return;
      els.forEach(function (e) { e.classList.add('lrn-ans'); });
      els[0].classList.add('lrn-ans-a'); els[els.length - 1].classList.add('lrn-ans-z');
      return;
    }
  }

  /* A table wider than the column scrolls inside its own frame instead of pushing the page sideways.
     A frame that scrolls can also be reached and scrolled from the keyboard, whether the frame is ours or the
     article's own. */
  function reach(frame, i) {
    if (frame.scrollWidth > frame.clientWidth + 2) {
      if (!frame.hasAttribute('tabindex')) { frame.tabIndex = 0; frame.setAttribute('data-lrn-reach', ''); }
      if (!frame.hasAttribute('role')) frame.setAttribute('role', 'region');
      if (!frame.hasAttribute('aria-label') && !frame.hasAttribute('aria-labelledby')) frame.setAttribute('aria-label', 'Table ' + (i + 1) + '. Scroll sideways to see all of it.');
      return true;
    }
    if (frame.hasAttribute('data-lrn-reach')) { frame.removeAttribute('tabindex'); frame.removeAttribute('data-lrn-reach'); }
    return false;
  }
  function tables(prose) {
    var frames = [];
    $$('table', prose).forEach(function (t) {
      var p = t.parentElement;
      while (p && p !== prose) { var ox = getComputedStyle(p).overflowX; if (ox === 'auto' || ox === 'scroll') { if (frames.indexOf(p) < 0) frames.push(p); return; } p = p.parentElement; }
      var w = d.createElement('div'); w.className = 'lrn-tw';
      t.parentNode.insertBefore(w, t); w.appendChild(t); frames.push(w);
      if (w.scrollWidth > w.clientWidth + 2) {
        var note = d.createElement('p'); note.className = 'lrn-tw-n'; note.textContent = 'Scroll sideways to see the whole table.';
        w.parentNode.insertBefore(note, w.nextSibling);
      }
    });
    function sync() { frames.forEach(reach); }
    sync();
    var timer; window.addEventListener('resize', function () { clearTimeout(timer); timer = setTimeout(sync, 200); });
  }

  /* The article's own contents list, if it has one: a list in the first part of the body whose links stay on the page. */
  function ownToc(prose) {
    var cands = $$('nav, div[class*="toc"], div[id*="toc"], ol, ul', prose);
    var limit = prose.getBoundingClientRect().top + prose.offsetHeight * 0.4;
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i], all = $$('a', el); if (all.length < 3) continue;
      var inp = all.filter(function (a) { return (a.getAttribute('href') || '').charAt(0) === '#'; });
      if (inp.length < 3 || inp.length / all.length < 0.8) continue;
      var len = inp.reduce(function (s, a) { return s + txt(a).length; }, 0) / inp.length;
      if (len < 8 || el.getBoundingClientRect().top > limit) continue;
      return el;
    }
    return null;
  }

  function toc(prose) {
    var nav = $('[data-lrn-toc]'); if (!nav) return;
    var ol = $('ol', nav), btn = $('.lrn-toc-btn', nav), rail = nav.closest('.lrn-rail'), items = [];
    var dec = function (s) { try { return decodeURIComponent(s); } catch (e) { return s; } };
    if (nav.getAttribute('data-lrn-toc') === 'auto') {
      /* The page arrives with the list from the headings already in the control. The article's own list replaces it
         only where that list works, so on most guides nothing in the control changes after the first paint. */
      var own = ownToc(prose), moved = false;
      if (own) {
        $$('a[href^="#"]', own).forEach(function (a) {
          var id = dec(a.getAttribute('href').slice(1));
          var t = txt(a); if (id && t && d.getElementById(id)) items.push([id, t]);
        });
        var prev = own.previousElementSibling;
        var named = !!prev && /^(H2|H3|H4|P|DIV)$/.test(prev.tagName) && txt(prev).length < 40 && /^(on this page|contents|table of contents|in this (guide|article)|jump to|what.s inside|what this guide covers)/i.test(txt(prev));
        /* moved: the article's own list works, so it goes to the rail. dead: the article calls it a contents list and
           not one of its links lands anywhere (two guides, 5 Oct 2026), so the list built from the headings stands in
           for it. Either way the page shows one contents list. A list that works in part is left where it is. */
        moved = items.length >= 3;
        var dead = !moved && named && !items.length;
        if (moved || dead) {
          own.classList.add('lrn-hide');
          if (named) {
            prev.classList.add('lrn-hide');
            var pp = prev.previousElementSibling; if (pp && pp.tagName === 'HR') pp.classList.add('lrn-hide');
          }
        }
        if (!moved) items = [];
      }
      if (!items.length) $$('h2[id]', prose).forEach(function (h) { if (!h.closest('.lrn-hide')) { var t = txt(h); if (t) items.push([h.id, t]); } });
      items = items.slice(0, 40);
      var have = $$('a', ol).map(function (a) { return dec((a.getAttribute('href') || '').slice(1)); });
      var same = !moved && have.length === items.length;
      if (same) items.forEach(function (it, i) { if (have[i] !== it[0]) same = false; });
      if (!same) {
        ol.textContent = '';
        items.forEach(function (it) {
          var li = d.createElement('li'), a = d.createElement('a'); a.href = '#' + encodeURIComponent(it[0]); a.textContent = it[1]; li.appendChild(a); ol.appendChild(li);
        });
      }
    }
    var links = $$('a', ol);
    if (links.length < 3) { nav.hidden = true; if (rail) rail.classList.add('is-empty'); return; }
    nav.hidden = false; if (rail) rail.classList.remove('is-empty');
    if (btn) btn.addEventListener('click', function () {
      var o = nav.getAttribute('data-open') === 'true';
      nav.setAttribute('data-open', o ? 'false' : 'true'); btn.setAttribute('aria-expanded', o ? 'false' : 'true');
    });
    ol.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) { nav.setAttribute('data-open', 'false'); if (btn) btn.setAttribute('aria-expanded', 'false'); }
    });
    if (!('IntersectionObserver' in window)) return;
    var map = {}, cur = null;
    links.forEach(function (a) { var id = a.getAttribute('href').slice(1); try { id = decodeURIComponent(id); } catch (e) {} if (d.getElementById(id)) map[id] = a; });
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || !map[e.target.id]) return;
        if (cur) cur.removeAttribute('aria-current');
        cur = map[e.target.id]; cur.setAttribute('aria-current', 'true');
        if (rail && rail.scrollHeight > rail.clientHeight + 4) {
          var r = cur.getBoundingClientRect(), rr = rail.getBoundingClientRect();
          if (r.top < rr.top || r.bottom > rr.bottom) rail.scrollTop += r.top - rr.top - rr.height / 2;
        }
      });
    }, { rootMargin: '0px 0px -70% 0px', threshold: 0 });
    Object.keys(map).forEach(function (id) { io.observe(d.getElementById(id)); });
  }

  function article() {
    var prose = $('[data-lrn-prose]'); if (!prose) return;
    dedupeTitle(prose); metaParas(prose); legacyHeads(prose); answer(prose); tables(prose); toc(prose);
  }

  /* ---------- results: filter the photo cards by area and by device ----------
     On a phone the unfiltered grid is folded after the first few photos (the number comes from the page). One button
     opens the rest. Choosing a filter always shows every match. */
  function results() {
    var box = $('[data-lrn-rz]'); if (!box) return;
    var items = $$('[data-lrn-rz-i]', box), count = $('[data-lrn-rz-n]', box), empty = $('[data-lrn-rz-0]', box);
    var list = $('[data-lrn-rz-cap]', box), more = $('[data-lrn-rz-more]', box);
    var cap = list ? parseInt(list.getAttribute('data-lrn-rz-cap'), 10) || 0 : 0;
    var fold = !!more && cap > 0 && items.length > cap + 2 && window.matchMedia('(max-width:760px)').matches;
    var state = {};
    function apply() {
      var n = 0, plain = Object.keys(state).every(function (k) { return state[k] === 'all'; });
      items.forEach(function (li, i) {
        var ok = Object.keys(state).every(function (k) { return state[k] === 'all' || (' ' + (li.getAttribute('data-' + k) || '') + ' ').indexOf(' ' + state[k] + ' ') > -1; });
        if (ok) n++;
        li.hidden = !ok || (fold && plain && i >= cap);
      });
      if (count) count.textContent = n + (n === 1 ? ' result' : ' results');
      if (empty) empty.hidden = n !== 0;
      if (more) more.hidden = !(fold && plain);
    }
    $$('[data-fg]', box).forEach(function (g) {
      var k = g.getAttribute('data-fg'); state[k] = 'all';
      g.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('button[data-f]') : null; if (!b) return;
        $$('button[data-f]', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        state[k] = b.getAttribute('data-f'); apply();
      });
    });
    var reset = $('[data-lrn-rz-reset]', box);
    if (reset) reset.addEventListener('click', function () {
      $$('[data-fg]', box).forEach(function (g) { state[g.getAttribute('data-fg')] = 'all'; $$('button[data-f]', g).forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-f') === 'all' ? 'true' : 'false'); }); });
      apply();
    });
    if (more) more.addEventListener('click', function (e) {
      if (!(e.target.closest && e.target.closest('button'))) return;
      fold = false; apply();
      var next = items[cap]; if (next) { next.tabIndex = -1; next.focus({ preventScroll: true }); }
    });
    if (fold) apply();
  }

  function init() { tasks(); article(); results(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();